import { registerRootComponent } from 'expo';

// eslint-disable-next-line import/extensions, import/no-unresolved
import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
